import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import NotFound404Exception from "@/exceptions/NotFound404Exception";
import { extractSadadInfo } from "@/apis/checkout/sendSadadInvoice";
import { toast } from "sonner";
export function api__getPayLinkOrderDetails(_x) {
  return _api__getPayLinkOrderDetails.apply(this, arguments);
}
function _api__getPayLinkOrderDetails() {
  _api__getPayLinkOrderDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var req, uuid, _res$data, _res$data2, _res$data3, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          req = _ref.req, uuid = _ref.uuid;
          _context.p = 1;
          _context.n = 2;
          return fetcher(req).get("/order/get-remaining?order_uuid=".concat(uuid, "&include=warranty,roadService,remainingBnplOptions,warrantyV2"));
        case 2:
          res = _context.v;
          if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success) {
            _context.n = 3;
            break;
          }
          throw new NotFound404Exception("Order not found");
        case 3:
          return _context.a(2, _objectSpread(_objectSpread({}, res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data), extractSadadInfo(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)));
        case 4:
          _context.p = 4;
          _t = _context.v;
          throw new NotFound404Exception('Order not found, Error occurred');
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _api__getPayLinkOrderDetails.apply(this, arguments);
}
export function api__getRemainingOrderDetails(_x2) {
  return _api__getRemainingOrderDetails.apply(this, arguments);
}
function _api__getRemainingOrderDetails() {
  _api__getRemainingOrderDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(order_id) {
    var _res$data4, _res$data5, _res$data6, res, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetcher().get("/order/get-remaining?order_id=".concat(order_id, "&include=warranty,roadService,remainingBnplOptions,warrantyV2"));
        case 1:
          res = _context2.v;
          if (res !== null && res !== void 0 && (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.success) {
            _context2.n = 2;
            break;
          }
          throw new NotFound404Exception('Order not found');
        case 2:
          return _context2.a(2, _objectSpread(_objectSpread({}, res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.data), extractSadadInfo(res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.data)));
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          throw new NotFound404Exception('Order not found, Error occurred');
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return _api__getRemainingOrderDetails.apply(this, arguments);
}
export function api__getFinanceRemainingOrderDetails(_x3) {
  return _api__getFinanceRemainingOrderDetails.apply(this, arguments);
}
function _api__getFinanceRemainingOrderDetails() {
  _api__getFinanceRemainingOrderDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(order_uuid) {
    var _res$data7, _res$data8, _res$data9, res, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetcher().get("/finance/get-vas-amount?order_uuid=".concat(order_uuid));
        case 1:
          res = _context3.v;
          if (res !== null && res !== void 0 && (_res$data7 = res.data) !== null && _res$data7 !== void 0 && _res$data7.success) {
            _context3.n = 2;
            break;
          }
          throw new NotFound404Exception('Order not found');
        case 2:
          return _context3.a(2, _objectSpread(_objectSpread({}, res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.data), extractSadadInfo(res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.data)));
        case 3:
          _context3.p = 3;
          _t3 = _context3.v;
          throw new NotFound404Exception('Order not found, Error occurred');
        case 4:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return _api__getFinanceRemainingOrderDetails.apply(this, arguments);
}
export function api__setWarrantyRemainingPayment(_x4, _x5) {
  return _api__setWarrantyRemainingPayment.apply(this, arguments);
}
function _api__setWarrantyRemainingPayment() {
  _api__setWarrantyRemainingPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(order_uuid, warranty_id) {
    var _res$data0, _res$data1, res, _t4;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.p = 0;
          _context4.n = 1;
          return fetcher().post("/order/set-warranty-remmining-payment?include=remainingBnplOptions,warrantyV2", {
            order_uuid: order_uuid,
            warranty_id: warranty_id
          });
        case 1:
          res = _context4.v;
          if (res !== null && res !== void 0 && (_res$data0 = res.data) !== null && _res$data0 !== void 0 && _res$data0.success) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, null);
        case 2:
          return _context4.a(2, res === null || res === void 0 ? void 0 : (_res$data1 = res.data) === null || _res$data1 === void 0 ? void 0 : _res$data1.data);
        case 3:
          _context4.p = 3;
          _t4 = _context4.v;
          toast.error("حدث خطأ، يرجى المحاولة مرة أخرى");
          return _context4.a(2, null);
      }
    }, _callee4, null, [[0, 3]]);
  }));
  return _api__setWarrantyRemainingPayment.apply(this, arguments);
}
export function api__generateVirtualIBAN(_x6) {
  return _api__generateVirtualIBAN.apply(this, arguments);
}
function _api__generateVirtualIBAN() {
  _api__generateVirtualIBAN = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(requestBody) {
    var _res$data10, res, _t5;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          _context5.n = 1;
          return fetcher().post('/order-tracking/virtual-iban', requestBody);
        case 1:
          res = _context5.v;
          return _context5.a(2, res === null || res === void 0 ? void 0 : (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.data);
        case 2:
          _context5.p = 2;
          _t5 = _context5.v;
          console.error(_t5);
          return _context5.a(2, null);
      }
    }, _callee5, null, [[0, 2]]);
  }));
  return _api__generateVirtualIBAN.apply(this, arguments);
} // Matches: res.data.data (the top-level "data" key in the API response)
export function api__saveVasOrCreatePaymentSession(_x7) {
  return _api__saveVasOrCreatePaymentSession.apply(this, arguments);
}
function _api__saveVasOrCreatePaymentSession() {
  _api__saveVasOrCreatePaymentSession = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(requestBody) {
    var _res$data11, res, _t6;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          _context6.p = 0;
          _context6.n = 1;
          return fetcher().post('/order-tracking/save-vas-or-create-payment-session', requestBody);
        case 1:
          res = _context6.v;
          if (!(res !== null && res !== void 0 && (_res$data11 = res.data) !== null && _res$data11 !== void 0 && _res$data11.success)) {
            _context6.n = 2;
            break;
          }
          return _context6.a(2, res.data.data);
        case 2:
          return _context6.a(2, null);
        case 3:
          _context6.p = 3;
          _t6 = _context6.v;
          console.error(_t6);
          return _context6.a(2, null);
      }
    }, _callee6, null, [[0, 3]]);
  }));
  return _api__saveVasOrCreatePaymentSession.apply(this, arguments);
}